import { Table } from "antd";
import { useEffect, useState } from "react";
import { assignTagToLead, deleteLead, getLeads, getLeadsCampaign } from "../../feature-module/crm/leads/api";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../feature-module/router/all_routes";
import React from "react";
import { getTagList } from "../../feature-module/crm/tags/tagAPI";
import Select from "react-select";
import ResponseModal from "./response_modal";

interface Lead {
  leadId: number;
  leadUuid: string;
  leadName: string;
  companyName?: string;
  phone: string;
  email: string;
  leadStageId?: number;
  leadStatus?: string;
  createdDate: string;
  leadOwner?: string;
  status: string;
}

interface CampaignMemberModalProps {
  recordId?: number;
}

const CampaignMemberModal = ({ recordId }: CampaignMemberModalProps) => {
  const navigate = useNavigate();
  const [data, setData] = useState<Lead[]>([]);
  const [selectedRecordIds, setSelectedRecordIds] = useState<number[]>([]);
  const [leadToDelete, setLeadToDelete] = useState<{
    id: number;
    name: string;
  } | null>(null);

  const leadsWithKeys = data.map((lead) => ({
    ...lead,
    key: lead.leadId,
  }));

  const [allTags, setAllTags] = useState<{ id: number; name: string }[]>([]);
  const [tagOptions, setTagOptions] = useState<{ label: string; value: number }[]>([]);
  const fetchTags = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await getTagList();
      const tags = response.data.data.map((tag: { id: number; name: string }) => ({
        label: tag.name,
        value: tag.id,
      }));
      setAllTags(response.data.data)
      setTagOptions(tags);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);
  const [showAssignTagModal, setShowAssignTagModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const [selectedTagIds, setSelectedTagIds] = useState<number[]>([]);
  const handleAssignTag = async () => {
    try {
      if (selectedRecordIds.length === 0 || selectedTagIds.length === 0) {
        setResponse({ status: "error", message: "Please select at least one lead and one tag." });
        return;
      }
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setResponse({ status: "error", message: "User ID not found!" });
        return;
      }

      const response = await assignTagToLead(selectedRecordIds, selectedTagIds, userId);
      console.log("Assign Tag Success:", response.data);
      setResponse({ status: "success", message: "Tags assigned successfully!" });
      setSelectedRecordIds([]);
      setSelectedTagIds([]);
      setShowAssignTagModal(false);
    } catch (error) {
      console.error("Error assigning tag:", error);
      setResponse({ status: "error", message: "Failed to assign tags. Please try again." });
    } finally {
      setShowMessageModal(true);
    }
  };

  const handleDeleteClick = (id: number, name: string) => {
    setLeadToDelete({ id, name });
  };
  const handleConfirmDelete = () => {
    if (!leadToDelete) return;
    deleteLead(leadToDelete.id)
      .then(() => {
        setData((prev) =>
          prev.filter((lead) => lead.leadId !== leadToDelete.id)
        );
      })
      .catch((error) => console.error("Error deleting lead:", error));
  };
  const handleClick = (leadUuid: string) => {
    navigate(`/leads-details/${leadUuid}`);
  };
  const columns = [
    {
      title: "Lead Name",
      dataIndex: "leadName",
      key: "leadName",
      render: (text: string, record: Lead) => (
        <Link to="#"
          className="title-name"
          data-bs-dismiss="modal"
          onClick={() => handleClick(record.leadUuid)}>
          {text}
        </Link>
      ),
      sorter: (a: Lead, b: Lead) => a.leadName.localeCompare(b.leadName),
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
      sorter: (a: Lead, b: Lead) =>
        a.companyName?.localeCompare(b.companyName || "") || 0,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      sorter: (a: Lead, b: Lead) => a.phone.localeCompare(b.phone),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a: Lead, b: Lead) => a.email.localeCompare(b.email),
    },
    {
      title: "Lead Status",
      dataIndex: "leadStatus",
      key: "leadStatus",
      sorter: (a: Lead, b: Lead) =>
        a.leadStatus?.localeCompare(b.leadStatus || "") || 0,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a: Lead, b: Lead) =>
        a.status?.localeCompare(b.status || "") || 0,
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      sorter: (a: Lead, b: Lead) => a.createdDate.localeCompare(b.createdDate),
    },
  ];

  useEffect(() => {
    const fetchLeads = async () => {
      if (!recordId) return;
      try {
        const response = await getLeadsCampaign(recordId);
        setData(response.data?.data || []);
      } catch (error) {
        console.error("Error fetching leads:", error);
        setData([]);
      }
    };
    fetchLeads();
  }, [recordId]);


  const rowSelection = {
    selectedRowKeys: selectedRecordIds,
    onChange: (selectedKeys: any[]) => {
      setSelectedRecordIds(selectedKeys);
    },
  };

  return (
    <>
      {/* Add Compose */}
      <div
        className="modal modal-xl custom-modal fade"
        id="add_campaign_member"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Campaign Members</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Lead"
                          name="search"
                        // value={searchValue}
                        // onChange={handleSearch}
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        <Link
                          to="#"
                          className="btn btn-primary ms-2"
                          data-bs-toggle="modal"
                          data-bs-target="#assignTagModal"
                        >
                          <i className="ti ti-tags me-2" />
                          Assign Tag
                        </Link>

                        <Link
                          to="#"
                          className="btn btn-primary ms-2"
                          data-bs-dismiss="modal"
                          onClick={() => navigate(all_routes.leads, { replace: true })}
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add Leads To Campaign
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>
                <div className="card-body">
                  <div className="table-responsive custom-table">
                    <Table
                      dataSource={leadsWithKeys}
                      columns={columns}
                      rowSelection={rowSelection}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Compose */}
      {/* Tag Modal */}
      <div className="modal custom-modal fade" id="assignTagModal" tabIndex={-1} role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Assign Tags to Leads</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="modal-body">
              <Select
                isMulti
                options={tagOptions}
                onChange={(selectedOptions) =>
                  setSelectedTagIds(selectedOptions ? selectedOptions.map((tag) => tag.value) : [])
                }
                placeholder="Select tags"
              />
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleAssignTag}>Assign</button>
            </div>
            <ResponseModal
              show={showMessageModal}
              onClose={() => setShowMessageModal(false)}
              response={response}
            />
          </div>
        </div>
      </div>
      {/* Delete Lead */}
      <div className="modal fade" id="delete_lead" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Lead?</h4>
                <p className="mb-0">
                  Are you sure you want to remove <br />
                  lead <strong>{leadToDelete?.name}</strong>?
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                  >
                    Yes, Delete {leadToDelete?.name}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Lead */}
    </>
  );
};

export default CampaignMemberModal;
